import {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import constant from "../../store/constant";
import axios from 'axios';
import {Intent, Toaster} from "@blueprintjs/core";
import {Position} from "monaco-editor";
import { useHistory } from 'react-router-dom';

const toaster = Toaster.create({
  position: Position.TOP,
  usePortal: true
});
const useChapter = () => {
  const [lesson, setLesson] = useState({
    loading: true
  });
  const dispatch = useDispatch();
  const { chapterId, lessonId } = useParams();
  const history = useHistory();

  // 获取章节目录
  useEffect(() => {
    axios.get('/api/course/learn_path', {
      params: {
        id: chapterId
      }
    }).then(response => {
      const { code, data } = response.data;
      if (code !== 0) {
        toaster.show({
          message: '获取章节目录失败',
          timeout: 3000,
          intent: Intent.DANGER
        });
        return;
      }
      const learnPath = (data || []).filter(item => String(item.id) === String(chapterId))[0] || {};
      const catalogs = (learnPath.lessons || []).map(lesson => ({
        title: lesson.title,
        label: lesson.title_en,
        id: lesson.id,
        status: lesson.finish_status,
        permission: lesson.permission,
      }));
      dispatch({
        type: constant.chapter.SET_CATALOGS,
        payload: [...catalogs]
      });
    });
  }, [dispatch, chapterId]);

  useEffect(() => {
    setLesson({
      loading: true
    });
    axios.get('/api/course/lesson', {
      params: {
        id: lessonId
      }
    }).then((response) => {
      const { code, data } = response.data;
      if (code !== 0) {
        toaster.show({
          message: '课程数据获取失败',
          timeout: 3000,
          intent: Intent.DANGER
        });
        return;
      }
      setLesson({
        loading: false,
        id: data.id,
        title: data.title,
        type: data.lesson_type,
        sections: [
          {
            content: data.content,
            version: '0.0.1'
          }
        ],    // 内容
        exercises: (data.instructions || []).map(exercise => ({
          id: exercise.id,
          title: exercise.title,
          desc: exercise.content,
          type: exercise.work_type, // radio / checkout /coding
          solutions: [],
          tips: '',
          code: exercise.user_code || exercise.default_code,
          finished: false,
          status: exercise.status,
          defaultCode: exercise.default_code
        })),
        codeEditor: {
          languageId: '71',
          code: '# 暂无代码'
        },
        conceptReview: {
          content: '',
          version: '0.0.1'
        },
        comments: [],
        permission: data.permission,
        status: data.finish_status,
        next: data.next_lesson.id,
        prev: data.prev_lesson.id,
        nextChapter: {
          chapterId: data.next_path_lesson.learn_path_id,
          lessonId: data.next_path_lesson.id,
          chapterName: data.next_path_lesson.learn_path_title
        },
        codeRunType: data.code_run_type
      });
    })
  }, [dispatch, lessonId]);

  useEffect(() => {
    if (lesson.permission === 'can_not_learn') {
      history.replace('/');
    }
  }, [history, lesson]);
  return { lesson, setLesson };
};

export default useChapter;
